import React from 'react';

import { Button } from "@deere/fuel-react";

// Custom button component to replace missing buttonComponent
const ButtonComponent = ({ 
  children, 
  variant = 'contained', 
  color = 'primary',
  onClick,
  handleFunction,
  disabled = false,
  className = '',
  btnTitle,
  tooltip,
  ...otherProps 
}) => {
  // Use handleFunction as onClick if onClick is not provided
  const handleClick = onClick || handleFunction;

  return (
    <Button
      variant={variant}
      color={color}
      onClick={handleClick}
      disabled={disabled}
      className={className}
      title={tooltip}
      {...otherProps}
    >
      {children || btnTitle}
    </Button>
  );
};

export default ButtonComponent;
